import FeatureService from "@/services/feature-service";
import { FeatureKeys } from "@/services/dropdown-enums";

/** Whether a child route is visible for the current user's roles. */
export const hasChildRouteAccess = (parentName, child, roles = {}) => {
  const nested = roles[parentName]?.[child.name];
  if (nested && typeof nested.view === "boolean") {
    return nested.view;
  }

  const topLevel = roles[child.name];
  if (topLevel && typeof topLevel.view === "boolean") {
    return topLevel.view;
  }

  // Submodule permission not defined — inherit parent module access (CRM appointments).
  return roles[parentName]?.view === true;
};

/** Stats analytics is appointment-product only, not CRM. */
const isAppointmentOnlyAnalyticsRoute = (child, features) =>
  child.name === "appointments-analytics" &&
  features &&
  FeatureService.hasFeature(features, FeatureKeys.CRM);

/** Child routes the user can access under a nav parent (e.g. Leads, Analytics). */
export const getVisibleChildRoutes = (item, roles = {}, features = null) => {
  if (!item?.childRoutes?.length) return [];
  return item.childRoutes.filter((child) => {
    if (isAppointmentOnlyAnalyticsRoute(child, features)) {
      return false;
    }
    return hasChildRouteAccess(item.name, child, roles);
  });
};